var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    _vm._m(0),
    _vm._v(" "),
    _vm.validate === 1
      ? _c("div", { staticClass: "row my-4 text-center" }, [
          _c(
            "div",
            { staticClass: "col-md-12" },
            [
              _c("h3", [_vm._v("กดปุ่ม Line เพิ่อเชื่อมต่อ Account ของคุณ")]),
              _vm._v(" "),
              _vm.isLineUser
                ? [
                    _c("img", {
                      staticClass: "img-disabled",
                      attrs: {
                        height: "38",
                        alt: "Line BeNeat",
                        src: "/static/img/btn-line.png"
                      }
                    }),
                    _vm._v(" "),
                    _c("h4", { staticClass: "mt-2" }, [
                      _vm._v(
                        "คุณลูกค้าได้เคยทำการเชื่อมต่อกับ Line เรียบร้อยแล้วค่ะ"
                      )
                    ])
                  ]
                : [
                    _c("a", { attrs: { href: _vm.apiUrl, target: "_blank" } }, [
                      _c("img", {
                        attrs: {
                          height: "38",
                          alt: "Line BeNeat",
                          src: "/static/img/btn-line.png"
                        }
                      })
                    ])
                  ]
            ],
            2
          )
        ])
      : _vm.validate === 0
      ? _c("div", { staticClass: "row my-4 text-center" }, [
          _c("div", { staticClass: "col-md-12" }, [
            _vm._v("\n      ระบบกำลังทำการตรวจสอบ กรุณารอสักครู่...\n    ")
          ])
        ])
      : _c("div", { staticClass: "row my-4 text-center" }, [
          _c("div", { staticClass: "col-md-12 text-danger" }, [
            _vm._v(
              "\n      เกิดข้อผิดพลาด กรุณาแจ้งแอดมินเพื่อทำการตรวจสอบค่ะ\n    "
            )
          ])
        ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row my-4" }, [
      _c("div", { staticClass: "col-md-8 offset-md-2 text-center" }, [
        _c("img", {
          staticClass: "img-fluid rounded",
          attrs: {
            src:
              "https://beneat.s3-ap-southeast-1.amazonaws.com/promotions/img_xl_line_coins.png",
            alt: ""
          }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "mt-4" }, [
          _c("div", [
            _vm._v("รับส่วนลด 50 บาท!! เพียงเพิ่มเราเป็นเพื่อนทาง Line")
          ]),
          _vm._v(" "),
          _c("div", [
            _vm._v(
              "Get discount 50 THB OFF by connecting us with your line messenger."
            )
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-790d1db2", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-790d1db2","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/information/LineLogin.vue
// module id = 1634
// module chunks = 0